import { createSlice } from '@reduxjs/toolkit';
import { MyFunds } from './myFundsModel';
import {
  deleteFundThunk,
  editMyFundsThunk,
  getAllClientsThunk,
  getFundThunk,
  saveMyFundsThunk,
} from './myFundsActions';

export interface MyFundsData {
  loading: boolean;
  data: MyFunds[];
  allFund: any;
  clientsData: any;
}

const initialState: MyFundsData = {
  loading: false,
  data: [],
  allFund: null,
  clientsData: null,
};

const myFundsSlice = createSlice({
  name: 'My Funds',
  initialState,
  reducers: {
    clearFundsData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveMyFundsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveMyFundsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(saveMyFundsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editMyFundsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(editMyFundsThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editMyFundsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getFundThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFundThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.allFund = action.payload?.data?.allBnyFunds || [];
      })
      .addCase(getFundThunk.rejected, (state) => {
        state.loading = false;
        state.allFund = [];
      })
      .addCase(getAllClientsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllClientsThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.clientsData = action.payload?.data?.allBnyClients;
      })
      .addCase(getAllClientsThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteFundThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteFundThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteFundThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { clearFundsData } = myFundsSlice.actions;
export default myFundsSlice.reducer;
